var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tppDateItemList" }, [
    _vm.homeType === "salesLeader_home"
      ? _c("div", [
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(
                  _vm._s(_vm.$t("dashboard.revenueAmount")) +
                    " / " +
                    _vm._s(_vm.$t("dashboard.revenueTarget2")) +
                    "   "
                ),
                _c("i", { staticClass: "el-icon-warning-outline" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _c("span", { staticClass: "num1 blue" }, [
                  _c("span", { staticClass: "num3" }, [
                    _vm._v(_vm._s(_vm.symbol)),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.paddingNum(_vm.sourceData.revenueAmount)) +
                      "M"
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "num2" }, [
                  _vm._v(
                    "/" +
                      _vm._s(_vm.symbol) +
                      _vm._s(_vm.paddingNum(_vm.sourceData.revenueTarget)) +
                      "M"
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.achievementRate"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _c("span", { staticClass: "num1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.paddingNum(_vm.sourceData.revenueTarget) == 0
                        ? "-"
                        : _vm.paddingNum(_vm.sourceData.attainment)
                    )
                  ),
                ]),
                _vm._v(" "),
                _vm.sourceData.attainment != undefined
                  ? _c("span", { staticClass: "num2" }, [_vm._v("%")])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.revenuePreTire"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _vm.sourceData.revenuePreTire != undefined
                  ? _c("span", { staticClass: "num3" }, [
                      _vm._v(_vm._s(_vm.symbol)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "num1" }, [
                  _vm._v(_vm._s(_vm.paddingNum(_vm.sourceData.revenuePreTire))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.revenueAverage"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _vm.sourceData.averagePrice != undefined
                  ? _c("span", { staticClass: "num3" }, [
                      _vm._v(_vm._s(_vm.symbol)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "num1" }, [
                  _vm._v(_vm._s(_vm.paddingNum(_vm.sourceData.averagePrice))),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("dashboard.grossMargin") +
                      "/" +
                      _vm.$t("dashboard.grossMarginTarget")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _c("span", { staticClass: "num1" }, [
                  _c("span", { staticClass: "num3" }, [
                    _vm._v(_vm._s(_vm.symbol)),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.paddingNum(_vm.sourceData.grossMargin)) +
                      "M\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "num2" }, [
                  _vm._v(
                    "/" +
                      _vm._s(_vm.symbol) +
                      _vm._s(_vm.paddingNum(_vm.sourceData.grossMarginTarget)) +
                      "M"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.grossMarginPreTire"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _vm.sourceData.grossMarginPreTire != undefined
                  ? _c("span", { staticClass: "num3" }, [
                      _vm._v(_vm._s(_vm.symbol)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "num1",
                    style: "color: " + _vm.sourceData.color + ";",
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.paddingNum(_vm.sourceData.grossMarginPreTire))
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ])
      : _c("div", [
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.revenueAmount")) + "  "),
                _c("i", { staticClass: "el-icon-warning-outline" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _c("span", { staticClass: "num1 blue" }, [
                  _c("span", { staticClass: "num3" }, [
                    _vm._v(_vm._s(_vm.symbol)),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.paddingNum(_vm.sourceData.revenueAmount))
                  ),
                  _c("span", { staticClass: "num3" }, [_vm._v("M")]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.revenueTarget"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _vm.sourceData.revenueTarget != undefined
                  ? _c("span", { staticClass: "num3" }, [
                      _vm._v(_vm._s(_vm.symbol)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "num1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.sourceData.revenueTarget
                        ? _vm.paddingNum(_vm.sourceData.revenueTarget)
                        : "-"
                    )
                  ),
                  _c("span", { staticClass: "num3" }, [_vm._v("M")]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tppDateItem" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.achievementRate"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nums" }, [
                _c("span", { staticClass: "num1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.sourceData.attainment
                        ? _vm.paddingNum(_vm.sourceData.attainment)
                        : "-"
                    )
                  ),
                ]),
                _vm._v(" "),
                _vm.sourceData.attainment != undefined
                  ? _c("span", { staticClass: "num2" }, [_vm._v("%")])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "tip" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
      _vm._v(_vm._s(_vm.$t("dashboard.revenueTip"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }